import React from 'react';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import { StoreItemType } from 'models/store-item.model';
import { ReactComponent as EditIcon } from 'assets/icons/edit-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';
const StoreItemsBulkActions = ({
  item,
  deleteFunc,
  setSelectedStoreItems
}: {
  item: any;
  deleteFunc: (arg1: any) => void;
  setSelectedStoreItems: (arg1: StoreItemType[]) => void;
}) => {
  const { setStoreItemsToEdit } = useInventoryStoreContext();
  const navigate = useNavigate();
  const routeToEditStoreItems = (items: StoreItemType[]) => {
    setStoreItemsToEdit(items);
    navigate(`${MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_BULK_EDIT}`);
  };
  return (
    <div className='absolute bottom-2 sm:bottom-8 left-4 sm:left-[10%] md:left-[18%] lg:left-[40%]'>
      {
        <div className='bulk-actions bg-white flex flex-wrap justify-start sm:justify-between items-center gap-6 sm:gap-4 mx-auto rounded-full py-5 px-[22px]'>
          <p className='text-[#6F7376] text-sm'>{item.length} items selected</p>
          <button
            onClick={() => routeToEditStoreItems(item)}
            className='cursor-pointer flex justify-between flex-nowrap items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'>
            <EditIcon />
            Update
          </button>

          <button
            onClick={() => {
              deleteFunc(item);
            }}
            className='cursor-pointer flex justify-between items-center gap-1 text-xs bg-[#F2F2F2] rounded-[8px] text-[#585F68] px-[12px] py-[6px] h-[29px]'>
            <DeleteIcon />
            Archive
          </button>

          <button
            onClick={() => {
              setSelectedStoreItems([]);
            }}
            className='cursor-pointer text-xs bg-[#E60A2B] rounded-[8px] text-white px-[12px] py-[6px] h-[29px]'>
            Done
          </button>
        </div>
      }
    </div>
  );
};

export default StoreItemsBulkActions;
